import Conexion_api from "@/api/Conexion_api.js"

export default function Validar_enlace (enlace) {
  return new Promise((resuelve) => {
    Conexion_api({
      body: {
        enlace: enlace
      },
      evento: "pedidos_configuraciones/validar_enlace"
    }).then(respuesta => {
        if(respuesta.data.error) return resuelve(false);            
        resuelve(respuesta);
    }).catch(err => {
        err = String(err);        
        console.error(err);
        resuelve(false);
    })
  })            
} 